// src-crsld/components/cta/cta.component.js
import { CtaController } from '@common/components/cta/cta.component';
import template from '@common/components/cta/cta.tpl.html';

class CrsldCtaController extends CtaController {
  static $inject = CtaController.$inject.concat(["userService"]);

  constructor(...args) {
    super(...args.slice(0, CtaController.$inject.length));
    this.$userService = args[CtaController.$inject.length];

    this.user = {};
    this.error = false;

  }

  async $onInit() {
    await super.$onInit();
    // Otherwise, it will be undefined from the base, and this default will apply.
    this.btnclass = this.btnclass || 'btn btn-primary-gradient btn-lg';
    this.btnarrow = this.btnarrow !== undefined ? this.btnarrow : 'mrs-icon mrs-arrow-right-long'

    // This runs after all data has been set in both controllers.
    if (!this.$scope.$$phase) {
      this.$scope.$apply();
    }

    const opts = this.page?.options || {};
    this.form = opts.hsform;
  }

  async optin($e) {
    let modalBasePath = `${this.AppService.config.pubPath}/modals/`;

    const specialModalPages = [];

    if (this.page && specialModalPages.indexOf(this.page.id) > -1) {
      this.modalinc = this.$sce.trustAsResourceUrl(`./${modalBasePath}modal.${this.page.id}.html`);
    }

    await super.optin($e);
  }

  async onClick() {
    super.onClick();
  }

  closeModal() {
    if (this.modalInstance) {
      this.modalInstance.hideModal(); // Use .close() or .dismiss() typically with $uibModal
      // Or this.modalInstance.hide(); if your service uses that name
    }
  }
}

class CrsldCtaComponent {
  bindings = {
    btntext: '@?',
    action: '@?',
    target: '@?',
    btnclass: '@?',
    btnarrow: '@?',
    btnalign: '@?',
    alumni: '@?',
    modalInstance: '<' // Add this binding: '<' for one-way binding
  };
  template = template;
  controller = CrsldCtaController;
}

export default angular
  .module('mrscta.component', [])
  .component('mrscta', new CrsldCtaComponent())
  .name;